import {Injectable} from '@angular/core';
import { Router } from '@angular/router';
import { Roles } from 'src/app/shared/model/Roles';
import {AuthService} from '../authentication/auth.service';

@Injectable({
  providedIn: 'root'
})
export class DealerUserAuthGuard  {
  constructor(public auth: AuthService, public router: Router) {
  }

  canActivate(): boolean {

    if (!this.auth.hasRole(Roles.DealerUser)) {
      this.router.navigate(['not-authorized']);
      return false;
    }

    return true;
  }
}
